import { ConfigProvider } from "antd";

// Charte graphique CTI Santé (valeurs extraites du logo SVG et de ctisante.com).
export const CTI_NAVY = "#012B43";
export const CTI_BLUE = "#195C84";
export const CTI_ORANGE = "#FF8801";
export const CTI_ORANGE_LIGHT = "#FFF1E0";
export const CTI_BG = "#F0F2F5";
export const CTI_FONT = '"Montserrat", sans-serif';

// Couleur primaire antd appliquée à l'exécution (antd.variable.css).
ConfigProvider.config({ theme: { primaryColor: CTI_BLUE } });
